import React, { Component } from 'react';

import { API } from '../../../../config';
import Util from '../../../../util';
import { withStyles } from "@material-ui/core";

import classNames from 'classnames';
import {translate} from "react-i18next";


const holdings = API.service('holdings');

const styles = theme => ({
  flexBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  tag: {
    position: 'relative',
    height: 50,
    fontSize: 12,
    fontFamily: 'Myriad',
    background: '#158eb5',
    width: '25%',
    border: '0.5px solid #1d7291',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',

    '&.first': {
      background: '#19648a',
    },
  },
});


class InvestorHoldings extends Component {

  constructor(props) {
    super(props);

    this.state = {
      company_order: false,
      order_count: 0,
      currency: '',
      symbol: '',
      heading: this.props.heading || "CANCEL"
    }
  }

  updateBalance() {
    var hh = 0;
    holdings.find({ query: { _investor_account: this.props.investor._account, _company_account: this.props.selectedCompany.account_number, _type: 'FREE' } }).then(h => {
      if (h.total >= 1) {
        h.data.forEach(hl => {
          hh = hh + hl._quantity;
          this.setState({
            holdings: hh
          })
        })
      } else {
        this.setState({
          holdings: 0
        })
      }
    })

    if (this.props.selectedCompany.currency === 'USD') {
      this.setState({
        currency: 'USD',
        symbol: '$'
      })
    } else if (this.props.selectedCompany.currency === 'GBP') {
      this.setState({
        currency: 'GBP',
        symbol: '£'
      })
    } else if (this.props.selectedCompany.currency === 'ANG') {
      this.setState({
        currency: 'XCG',
        symbol: 'Cg'
      })
    } else if (this.props.selectedCompany.currency === 'XCG') {
      this.setState({
        currency: 'XCG',
        symbol: 'Cg'
      })
    } else if (this.props.selectedCompany.currency === 'AUD') {
      this.setState({
        currency: 'AUD',
        symbol: '$'
      })
    } else if (this.props.selectedCompany.currency === 'EUR') {
      this.setState({
        currency: 'EUR',
        symbol: '€'
      })
    }
  }

  componentDidMount() {
    const app = this;
    this.updateBalance();

    holdings.on("created", c => {
      if (c._investor_account === this.props.investor._account) {
        this.updateBalance();
      }
    })

    holdings.on("updated", c => {
      if (c._investor_account === this.props.investor._account) {
        this.updateBalance();
      }
    })

    this.timer = setInterval(function () {
      app.updateBalance();
    }, 2000)
  }

  componentWillReceiveProps(nextProp) {
    this.updateBalance();
  }

  render() {
    const { classes, t } = this.props;

    return (
      <div className={classes.flexBox}
           style={{
             marginTop: 0,
             marginBottom: 0,
             marginLeft: 20,
             marginRight: 20
           }}>
        <div className={classNames(classes.tag, 'first')}>
          <span style={{ textAlign: 'center', color: 'white' }}>
            {this.props.selectedCompany.symbol} <br />{t('user_panel_trade_current_holdings')}
					</span>
          <span className='material-icons' style={{ color: 'white', position: 'absolute', right: '-16px', zIndex: 1, fontSize: '35px' }}>arrow_left</span>
        </div>
        <div className={classes.tag} style={{ width: '30%' }}>
          <span>
            {t('user_panel_trade_units')}:&nbsp;
            <b>{Util.addThousandCommas(this.state.holdings)}</b>
          </span>
        </div>
        <div className={classes.tag} style={{ width: '45%' }}>
          <span>
            <nobr>{t('user_panel_trade_market_value')}:</nobr>&nbsp;
            <b>
              {this.state.symbol}{Util.addThousandCommas((parseFloat(this.props.selectedCompany.share_price) * parseFloat(this.state.holdings)), '0,0.00')}&nbsp;
              {this.state.currency}
            </b>
          </span>
        </div>
      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(translate('translations')(InvestorHoldings));
